<template>
  <div class="form-group row">
    <label class="col-2 text-right">保障公式</label>
    <div class="col-10 d-inline-grid">
      <!-- 保障公式-1 -->
      <div class="mb-15">
        <span class="lh-40">領回</span>
        <select
          class="form-control form-control-inline form-wide w-250"
          :class="{ 'is-invalid': validate.isCalc_basisErr }"
          v-model="form.calc_basis"
        >
          <option
            v-for="item in pageControl.calculationBasis"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40">的</span>
        <input
          type="number"
          class="form-control form-control-inline show-input w-100"
          :class="{ 'is-invalid': validate.isPeriod_lowerErr }"
          v-model="form.period_lower"
          :min="0"
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
          maxlength="8"
        />
        <select
          class="form-control form-control-inline form-wide w-100"
          :class="{ 'is-invalid': validate.isUnit_lowerErr }"
          v-model="form.unit_lower"
        >
          <option
            v-for="item in pageControl.noDollarUnits"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
        <span class="lh-40">給付</span>
      </div>
    </div>
  </div>
</template>
<script>
import { commonMixin } from "@/mixins/common";
export default {
  name: "CoveragePageFormulaGoodwish",
  mixins: [commonMixin],
  data() {
    return {};
  },
  props: {
    pageControl: {
      type: Object,
      default: () => {
        return {};
      },
    },
    form: {
      type: Object,
      default: () => {
        return {};
      },
    },
    validate: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>
